// Translates DatoCMS gradient colors to the correct Design System variant
import {
  Progress,
  type ProgressProps,
} from '@ironhack/design-system2/components/progress';
import { type Gradient } from '@ironhack/design-system2/utils';
import { type ComponentProps, type ReactElement } from 'react';

type Variant = ComponentProps<typeof Progress>['variant'];

const gradientToVariantMap: Partial<Record<Gradient, Variant>> = {
  brand: 'default',
  interactive: 'default',
};

export type Props = {
  color: Gradient;
} & Omit<ProgressProps, 'color'>;

export const ProgressBar = (props: Props): ReactElement => {
  const { color, ...progressProps } = props;

  const variant = gradientToVariantMap[color] ?? color;

  return <Progress variant={variant} {...progressProps} />;
};
